import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';
import { TagItem } from '@atlassian/jira-list-with-popup/src/ui/tag-item/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

type ColorProps = {
	color?: string | null;
	isColored?: boolean;
};

export type Props = ColorProps &
	(
		| {
				text?: string | null;
				noValueText: string;
		  }
		| {
				text: string;
				noValueText?: never;
		  }
	);

export const TagGroupHeaderContent = ({ text, noValueText, ...colorProps }: Props) => {
	return text ? (
		<TagItem
			name={text}
			{...colorProps}
			isHoverPopoverEnabled={fg('group_by_any_field_tag_tooltip')}
		/>
	) : (
		<Text>{noValueText}</Text>
	);
};
